import { useSuspenseQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '../lib/queryKeys'
import subscriptionService from '../lib/services/subscriptionService'
import useCurrentCompanyOrFail from './useCurrentCompanyOrFail'
import useCurrentCompanyUserOrFail from './useCurrentCompanyUserOrFail'

export default function useSubscriptionsQuery() {
  const currentCompany = useCurrentCompanyOrFail()
  const currentCompanyUser = useCurrentCompanyUserOrFail()

  return useSuspenseQuery({
    queryKey: QUERY_KEYS.subscriptions(
      currentCompany.id,
      currentCompanyUser.id,
    ),
    queryFn: async () => {
      const [companySubscriptions, companyUserSubscriptions] =
        await Promise.all([
          subscriptionService.getCompanySubscriptions(currentCompany.id),
          subscriptionService.getCompanyUserSubscriptions(
            currentCompanyUser.id,
          ),
        ])

      return [
        ...companySubscriptions['hydra:member'],
        ...companyUserSubscriptions['hydra:member'],
      ]
    },
    refetchOnWindowFocus: false,
  })
}
